import * as React from "react";

const SvgCertified = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 700 700"
    style={{
      enableBackground: "new 0 0 700 700",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <path d="m424.5 273.3-105.6 94-41.3-46c-6.7-6.9-16.4-9.9-25.8-7.8-9.4 2.1-17 8.9-20.1 18-3.1 9.1-1.2 19.1 4.9 26.5l77.9 86.9L461 314.3c7-6.6 10-16.4 8-25.8-2-9.4-8.9-17.1-18-20.2-9.1-3.2-19.2-1.3-26.5 5z" />
    <path d="M623.5 261c-9.9-30.4 0-70.7-18.6-96.4s-60.3-28.9-85.9-47.4c-25.6-18.6-41.3-57-71.6-66.9-29.4-9.5-64.9 12.1-97.4 12.1s-68-21.7-97.4-12.1c-30.3 9.8-46.3 48.9-71.6 67-25.3 18.1-67.2 21.9-85.8 47.5-18.6 25.6-8.7 65.9-18.7 96.2-9.4 29.4-41.5 56.4-41.5 88.9s32.1 59.5 41.5 88.9c9.9 30.4 0 70.7 18.6 96.4 18.6 25.7 60.3 28.9 85.9 47.4 25.6 18.6 41.2 57.2 71.6 67 29.3 9.5 64.9-12.2 97.4-12.2s68 21.7 97.4 12.2c30.4-9.9 46.3-48.6 71.6-67 25.3-18.4 67.2-21.9 85.9-47.4 18.6-25.5 8.8-65.9 18.6-96.4 9.3-29.4 41.5-56.4 41.5-88.9s-32.1-59.5-41.5-88.9zM350 550.4c-53.2 0-104.1-21.1-141.7-58.7-37.6-37.6-58.7-88.6-58.7-141.7s21.1-104.1 58.7-141.7c37.6-37.6 88.6-58.7 141.7-58.7s104.1 21.1 141.7 58.7c37.6 37.6 58.7 88.6 58.7 141.7 0 35.2-9.3 69.8-26.9 100.2-17.6 30.5-42.9 55.8-73.4 73.4-30.4 17.5-64.9 26.8-100.1 26.8z" />
  </svg>
);

export default SvgCertified;
